import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import "datatables.net-dt/css/jquery.dataTables.css";
import $ from "jquery";
import "datatables.net";

function OrderManagement() {
  const navigate = useNavigate();
  const location = useLocation();
  const [filter, setFilter] = useState("all");
  const [searchParams] = useSearchParams();
  const EventId = searchParams.get("id");
  const fetchData = async () => {
    try {
      const businessId = localStorage.getItem("business_id");
      const signupStatus = localStorage.getItem("signup");
      let params = {};
      if (businessId && signupStatus === "user") {
        params.business_id = businessId;
      }

      const response = await axios.get(
        process.env.REACT_APP_APIURL + "event/admin/list",
        { params }
      );
      const events = response.data.result[0]?.events || [];
      const filteredEvents =
        filter === "all"
          ? events
          : events.filter((item) => item.purchase_status === filter);

      console.log("filteredEvents");
      console.log(filteredEvents);

      const orders = filteredEvents.map((item, index) => ({
        orderId: `ORD00${index + 1}`,
        customerName: item.user_name || "N/A",
        orderDate: item.created_date
          ? new Date(item.created_date).toLocaleDateString()
          : "N/A",
        deliveryDate: item.event_date || "N/A",
        totalAmount: item.total_price
          ? `Rs. ${(parseFloat(item.total_price) * 1.05 + 60).toFixed(2)}`
          : "N/A",
        paymentStatus: item.payment_status || "",
        // orderStatus: item.purchase_status || "N/A",
        orderStatus: `<span class="status-text ${item.purchase_status.toLowerCase()}">${
        item.purchase_status==="paid"?"Ordered":item.purchase_status || "N/A"
        }</span>`,
        shippingAddress: `${item.address || ""}, ${item.city || ""}, ${
          item.state || ""
        }, ${item.zip_code || ""}`,
        contactDetails: item.phone_number || "N/A",
        paymentMethod: "Credit Card",
        shippingMethod: "Express Shipping",
        actions: `<button class="btn btn-sm btn-info view-order-btn" data-id="${item._id}">View</button>`,
      }));

      $("#OrderManagement").DataTable({
        data: orders,
        columns: [
          { data: "orderId", title: "Order ID" },
          { data: "customerName", title: "Customer Name" },
          { data: "orderDate", title: "Order Date" },
          { data: "deliveryDate", title: "Delivery Date" },
          { data: "totalAmount", title: "Total Amount" },
          { data: "paymentStatus", title: "Payment Status" },
          {
            data: "orderStatus",
            title: "Order Status",
            orderable: true,
            render: (data) => data,
          },
          { data: "shippingAddress", title: "Shipping Address" },
          { data: "contactDetails", title: "Contact Details" },
          { data: "paymentMethod", title: "Payment Method" },
          { data: "shippingMethod", title: "Shipping Method" },
          { data: "actions", title: "Actions", orderable: false },
        ],
        destroy: true, // Allow reinitialization
        responsive: true,
        autoWidth: false,
        paging: true, // Enable pagination
        searching: true, // Enable search
        lengthChange: true, // Allow changing number of rows displayed
      });

      $("#OrderManagement").on("click", ".view-order-btn", function () {
        const orderId = $(this).data("id");
        viewOrder(orderId);
      });
    } catch (error) {
      console.error("Error fetching order data:", error);
      alert("Failed to fetch order data. Please try again later.");
    }
  };

  const viewOrder = (orderId) => {
    navigate(`/ordermanagement_view?id=${orderId}`);
  };

  useEffect(() => {
    fetchData();

    return () => {
      if ($.fn.DataTable.isDataTable("#OrderManagement")) {
        $("#OrderManagement").DataTable().destroy();
      }
    };
  }, [filter]);

  return (
    <div className="wrapper" id="root">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">Order Management</h1>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row mb-3">
              <div className="col-lg-12 d-flex justify-content-start gap-3 flex-wrap">
                <button
                  className={`btn btn-primary ${
                    filter === "all" ? "active" : ""
                  }`}
                  onClick={() => setFilter("all")}
                >
                  All
                </button>
                <button
                  className={`btn btn-warning ${
                    filter === "ordered" ? "active" : ""
                  }`}
                  onClick={() => setFilter("ordered")}
                >
                  Ordered
                </button>
                <button
                  className={`btn btn-success ${
                    filter === "delivered" ? "active" : ""
                  }`}
                  onClick={() => setFilter("delivered")}
                >
                  Delivered
                </button>
                <button
                  className={`btn btn-info ${
                    filter === "shipped" ? "active" : ""
                  }`}
                  onClick={() => setFilter("shipped")}
                >
                  Shipped
                </button>
                <button
                  className={`btn btn-danger ${
                    filter === "cancelled" ? "active" : ""
                  }`}
                  onClick={() => setFilter("cancelled")}
                >
                  Cancelled
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="table-responsive">
                  <table
                    id="OrderManagement"
                    className="table table-striped table-bordered txt_lft"
                    style={{ width: "100%" }}
                  ></table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default OrderManagement;
